/*
 *des 云市场
 *create by lileilei
 */
'use strict';
angular.module('cloudModule', ['cloudRouterModule'])
    . controller('cloudController', ['$scope', '$state', '$location', 'trsHttpService',
        function($scope, $state, $location, trsHttpService) {
            initStatus();
            getCloudRights();

            /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
            function initStatus() {
                calcBodyHeight();
                $scope.status = {
                    cloudAppRights: [],
                };
            }

            /**
         * [calcBodyHeight description] 计算body的高度 不出滚动条
         * @return {[type]} [description]
         */
            function calcBodyHeight() {
                $('.cloud_body').css({ 'overflowY': 'auto' });
                $('body').css({ 'overflow': 'hidden' });
                window.onresize = function() {
                    var htmlHei = $('html').height();
                    $('.cloud_body').height(htmlHei - 60);
                };
            }
            $scope.goToWangcha = function(){
                if (!$scope.getCloudAppRight(1, 'CANCLICK')) {return;}
                window.open('/wcm/checkRight.do?MethodName=checkLoginRedirect&appId=1');
            };
            $scope.getCloudAppRight = function(id, name){
                let result;
                $scope.status.cloudAppRights.map(function(item){
                    if (item.APPID == id) {result = item[name];}                    
                });
                return result == 'true';
            };
            function getCloudRights(){
                let params = {
                    serviceid: 'mlf_yunmart',
                    methodname: 'queryYunMartApps'
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data){
                    $scope.status.cloudAppRights = data;
                });
            }
        }
    ]);
